import * as z from "zod/v4";

import { partnerStatusSchema, partnerSummarySchema } from "./shared";

export const listPartners = {
  name: "listPartners" as const,
  input: z.object({
    /** Plain integer offset to match the rest of the admin SDK. */
    offset: z.number().int().min(0).default(0),
    limit: z.number().int().min(1).max(100).default(25),
    /**
     * Substring search across email / name / referral_code via the
     * trigram indexes added in 20260426143202_add_partner_account_search_indexes.
     * Empty string means no filter.
     */
    searchQuery: z.string().max(200).optional(),
    /** "all" or omitted = no filter; otherwise restrict to that status. */
    statusFilter: z.union([partnerStatusSchema, z.literal("all")]).optional(),
  }),
  output: z.object({
    partners: z.array(partnerSummarySchema),
    total: z.number().int(),
  }),
};
